module.exports = __webpack_public_path__ + "img/error-404.eaedf210.png";